import React from 'react';
import styleable from 'react-styleable';
import Loader from '../spinner';
import ExtendResultInfo from './pages/extend-info';
import ExtendResultForm from './pages/extend-form';
import ExtendResultError from './modals/error';
import css from './index.scss';

const ExtendResult = (props) => {
    const { extendingResultsStatusType } = props;

    const extendResultView = (extendingResultsStatusType === '') ?
        (<div className={css.loader}>
            <Loader color="grey" size="15px" />
        </div>) : (
            <div className={css.extendResultContainer}>
                <ExtendResultInfo {...props} />
                <ExtendResultForm {...props} />
                <ExtendResultError {...props} />
            </div>);

    return extendResultView;
};

export default styleable(css)(ExtendResult);



// WEBPACK FOOTER //
// ./app/components/extend-result/index.js